import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import Image from 'next/image';
import { TBlogModuleArticleSection } from '../../blog/blog.types';

import './BlogArticleModuleSection.scss';

type Props = {
  mobile: boolean;
  module: TBlogModuleArticleSection;
};

export const BlogArticleModuleSection: React.FC<Props> = ({
  module: { sectionImage, title, content },
  mobile = false,
}) => {
  const imgSrc = assetUrl(sectionImage);

  if (mobile) {
    return (
      <div className='BlogArticleModuleSection BlogArticleModuleSection--mobile'>
        {imgSrc && (
          <div className='BlogArticleModuleSection__image-container--mobile'>
            <Image
              className='BlogArticleModuleSection__image--mobile'
              src={imgSrc}
              fill
              alt='section'
            />
          </div>
        )}

        <div className='BlogArticleModuleSection__title-wrapper--mobile'>
          <Typography variant='h3'>{title}</Typography>
        </div>

        {content && (
          <div
            className='BlogArticleModuleSection__content--mobile BlogArticleModuleSection__content-WYSIWYG'
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    );
  }

  return (
    <div className='BlogArticleModuleSection BlogArticleModuleSection--desktop'>
      {imgSrc && (
        <div className='BlogArticleModuleSection__image-container--desktop'>
          <Image
            className='BlogArticleModuleSection__image--desktop'
            src={imgSrc}
            fill
            alt='section'
          />
        </div>
      )}

      <div className='BlogArticleModuleSection__title-wrapper--desktop'>
        <Typography
          className='BlogArticleModuleSection__title--desktop'
          variant='h3'
        >
          {title}
        </Typography>
      </div>

      {content && (
        <div
          className='BlogArticleModuleSection__content--desktop BlogArticleModuleSection__content-WYSIWYG'
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};
